import axios from 'axios';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
// Base URL for your API
const API_URL = process.env.REACT_APP_API_BASE_URL;
console.log("API URL:", API_URL);

const environment = process.env.REACT_APP_ENVIRONMENT;
console.log("Environment:", environment);

// Create an Axios instance with default configuration
const apiClient = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',  // Default headers for requests
  },
});

// Hook to load user data and update the token dynamically
const useApiClient = () => {
  const [isTokenSet, setIsTokenSet] = useState(false);
  const navigate = useNavigate();
  useEffect(() => {
    const userData = sessionStorage.getItem('user');
    const parsedUserData = userData ? JSON.parse(userData) : null;

    if (parsedUserData) {
      // Update the token dynamically when available
      apiClient.defaults.headers['wg_token'] = parsedUserData;
      setIsTokenSet(true); // Indicate the token is set
    }else {
      navigate('/', { replace: true });
    }
  }, []); // Run only once on component mount

  return { isTokenSet };
};

// This is where the hook is used inside a React component
const YourComponent = () => {
  const { isTokenSet } = useApiClient();

  // You can use the apiClient here if needed
  useEffect(() => {
    if (isTokenSet) {
    }
  }, [isTokenSet]);

  return <div>Your Component</div>;
};

apiClient.interceptors.request.use(
  (config) => {
    const userData = sessionStorage.getItem('user');
    console.log("userData",userData);
    
    const parsedUserData = userData ? JSON.parse(userData) : null;

    if (parsedUserData) {
      config.headers['wg_token'] = parsedUserData;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

apiClient.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response) {
      const { status, data } = error.response;

      switch (status) {
        case 401:
          console.log('Unauthorized access. Token expired or missing.');
          break;
        default:
          console.error('An error occurred:', data?.message);
      }
    }
    return Promise.reject(error);
  }
);

export default apiClient;
export { useApiClient, YourComponent };